import { connect } from 'react-redux';

import { deleteById, Entities, fetchAll, getEntities, patch, search } from 'src/common/index';
import { fetchAdminNews } from 'src/actions/admin-news';
import AdminAdditionalFeesAreaAdministration from 'src/components/admin/geofence-areas/admin-additional-fees-area-administration';
import { addErrorNotification, addNotification } from 'src/actions/notifications';
import { deleteGeoFenceArea } from 'src/actions/geo-fence';

const mapStateToProps = state => {
    return {
        busCompanies: getEntities(state, Entities.BUS_COMPANY),
        geofenceAreas: getEntities(state, Entities.GEOFENCE_AREA),
    };
};

const AdminAdditionalFeesAreaAdministrationContainer = connect(mapStateToProps, {
    fetchAdminNews,
    search,
    fetchAll,
    deleteById,
    patch,
    addErrorNotification,
    addNotification,
    deleteGeoFenceArea,
})(AdminAdditionalFeesAreaAdministration);

export default AdminAdditionalFeesAreaAdministrationContainer;
